import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { RoundedHorizontalBarChart } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';
import './AwardStatisticSection.scss';

const AwardStatisticSectionImpl: React.FC = () => {
  const {
    awardStore,
    awardPageUiStore,
  } = useStores();

  return (
    <FlexBox
      direction='column'
      className='award-statistic-section'
    >
      <div>
        <Text
          size={400}
          weight='semibold'
        >
          Number of nominations
        </Text>
        <RoundedHorizontalBarChart
          id='submitted-nominations-count'
          primaryData={{
            name: 'Submitted',
            color: '#0078D4',
            value: awardPageUiStore.submittedNominationsCount,
          }}
          secondaryData={{
            name: 'Incomplete',
            color: '#50E6FF',
            value: awardPageUiStore.incompleteNominationsCount,
          }}
        />
      </div>
      <div>
        <Text
          size={400}
          weight='semibold'
        >
          Pass vs. disqualify
        </Text>
        <RoundedHorizontalBarChart
          id='passed-nominations-count'
          primaryData={{
            name: 'Pass',
            color: '#107C10',
            value: awardPageUiStore.passedNominationsCount,
          }}
          secondaryData={{
            name: 'Disqualified',
            color: '#9BF00B',
            value: awardPageUiStore.disqualifiedNominationsCount,
          }}
        />
        {awardPageUiStore.pendingAffirmationNominationsCount > 0 && (
          <div className='pending-affirmation'>
            <Text size={300}>Pending affirmation</Text>
            <Text size={300} weight='semibold'>{awardPageUiStore.pendingAffirmationNominationsCount}</Text>
          </div>
        )}
      </div>
      <div>
        <Text
          size={400}
          weight='semibold'
        >
          Judges started
        </Text>
        <RoundedHorizontalBarChart
          id='judges-active-count'
          primaryData={{
            name: 'Active',
            color: '#8661C5',
            value: awardStore.isJudgingWindowOpen ? awardPageUiStore.judgesActiveCount : 0,
          }}
          secondaryData={{
            name: 'Inactive',
            color: '#D59DFF',
            value: awardStore.isJudgingWindowOpen ? awardPageUiStore.judgesInActiveCount : 0,
          }}
        />
      </div>
      <div>
        <Text
          size={400}
          weight='semibold'
        >
          Judged nominations
        </Text>
        <RoundedHorizontalBarChart
          id='judged-nominations-completed-count'
          primaryData={{
            name: 'Complete',
            color: '#008575',
            value: awardStore.isJudgingWindowOpen ? awardPageUiStore.judgedNominationsCompletedCount : 0,
          }}
          secondaryData={{
            name: 'Incomplete',
            color: '#30E5D0',
            value: awardStore.isJudgingWindowOpen ? awardPageUiStore.judgedNominationsInProgressCount : 0,
          }}
        />
      </div>
    </FlexBox>
  );
}

export const AwardStatisticSection = observer(AwardStatisticSectionImpl);
